<template>
  <input
    v-bind="$attrs"
    :readonly="readonly"
    :disabled="disabled"
    :required="required"
    :type="type"
    :value="modelValue || value"
    :class="{
      'w-full': full,
      'z-10 border-transparent': inGroup,
      'rounded-md border-gray-300 shadow-sm focus:z-10 focus:ring-4 focus:ring-blue-300':
        !inGroup,
      block: true,
      'pl-11': icon,
      ...getFormInputClasses({
        size,
        readonly,
        disabled,
      }),
    }"
    @input="onChange"
    @change="onChange"
  />
</template>
<script setup lang="ts">
import type { FormSize, MsIcon } from '~/lib/services/types';
import { getFormInputClasses } from '~/lib/services/helpers';

withDefaults(
  defineProps<{
    inGroup?: boolean;
    value?: string | number | null;
    modelValue?: string | number | null;
    size?: FormSize;
    required?: boolean;
    type?: string;
    readonly?: boolean;
    disabled?: boolean;
    icon?: MsIcon;
    full?: boolean;
  }>(),
  {
    inGroup: false,
    full: true,
    readonly: false,
    size: 'md',
    required: false,
    disabled: false,
    type: 'text',
    icon: undefined,
    value: '',
    modelValue: '',
  },
);

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.value);
  emit('change', target.value);
};

const emit = defineEmits<{
  (e: 'change' | 'update:modelValue', p: string): void;
}>();
defineOptions({
  inheritAttrs: false,
});
</script>
